import * as React from 'react';

function Times(props) {
	return (
		<svg
			width="50"
			height="50"
			viewBox="0 0 50 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
            {...props}
		>
			<circle cx="25" cy="25" r="25" fill="white" fill-opacity="0.15" />
			<path d="M17.1426 17.1426L32.8569 32.8569" stroke="white" strokeWidth="2" />
			<path d="M17.1426 32.8574L32.8569 17.1431" stroke="white" strokeWidth="2" />
		</svg>
	);
}

export default Times;
